export default __webpack_public_path__ + "static/tokens-ee11db98e43b9136578edc3d5d6046d8.png";